<template>
  <div class="log">
    <v-btn
      class="ma-2 add-charge-trigger-btn"
      color="orange"
      dark
      @click.stop="dialog = false"
      :disabled="processing || status <= 1 || viewOnly == 'view' || status == 8"
      @click="check()"
      target="_blank"
    >
      + Add Additional Charges
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="48rem"
      persistent
      content-class="add-charge-dialog"
      class="add-charge-dialog-wrap"
    >
      <v-form ref="form" onsubmit="return false;">
        <v-card class="comments-view add-charge-card">
          <v-card-title class="add-charge-title">
            <span class="headline">Add Additional Charges</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              :disabled="processing"
              @click.prevent="close"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <v-spacer class="add-charge-body">
            <v-card-text class="nospace add-charge-content">
              <div class="add-charge-form">
                <div
                  class="add-charge-price-type"
                  v-if="
                    chargesType == 'Inclusive' &&
                    costMargin != '0' &&
                    miscellaneousChargeShow != true
                  "
                >
                  <v-radio-group
                    class="mt-0 pt-0"
                    v-model="priceType"
                    row
                    :mandatory="true"
                    :rules="[rules.required]"
                  >
                    <v-radio
                      label="Exclusive"
                      value="Exclusive"
                      color="orange"
                    ></v-radio>
                    <v-radio
                      label="Inclusive"
                      value="Inclusive"
                      color="orange"
                    ></v-radio>
                  </v-radio-group>
                  <p class="add-charge-hint">
                    {{
                      priceType == "Inclusive"
                        ? "Additional prices will not be included in invoices."
                        : "Additional prices will be included in invoices."
                    }}
                  </p>
                </div>

                <v-switch
                  class="add-charge-switch"
                  color="orange"
                  v-model="miscellaneousChargeShow"
                  label="Add Miscellaneous Charge"
                  hide-details
                  @change="cleanData()"
                ></v-switch>

                <div class="add-charge-grid">
                  <div class="add-charge-field">
                    <label class="add-charge-label">Assignment Id</label>
                    <v-text-field
                      class="add-charge-input"
                      placeholder="Assignment Id"
                      :disabled="ids ? true : false"
                      v-model="assId"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div class="add-charge-field">
                    <label class="add-charge-label">Description type</label>
                    <v-autocomplete
                      class="add-charge-input"
                      v-model="descriptionType"
                      :items="additionalChargeList"
                      placeholder="Select description type"
                      :disabled="processing"
                      :menu-props="{ offsetY: true }"
                      return-object
                      hide-details
                    ></v-autocomplete>
                  </div>

                  <div class="add-charge-field" v-if="!miscellaneousChargeShow">
                    <label class="add-charge-label">Customer Price</label>
                    <v-text-field
                      class="add-charge-input"
                      placeholder="Customer Price"
                      type="number"
                      max="1000000"
                      :suffix="currency1"
                      :disabled="processing"
                      v-model="costMargin"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div class="add-charge-field" v-if="!miscellaneousChargeShow">
                    <label class="add-charge-label">{{ operatorChargesLabel }}</label>
                    <v-text-field
                      class="add-charge-input"
                      :placeholder="operatorChargesLabel"
                      :title="`${operatorRoleLabel} Charges`"
                      type="number"
                      max="1000000"
                      :suffix="currency1"
                      :disabled="processing"
                      v-model="amount"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div
                    class="add-charge-field add-charge-field--wide"
                    v-if="miscellaneousChargeShow"
                  >
                    <label class="add-charge-label">Miscellaneous Charges</label>
                    <v-text-field
                      class="add-charge-input"
                      placeholder="Miscellaneous Charges"
                      type="number"
                      max="1000000"
                      :suffix="currency1"
                      :disabled="processing"
                      v-model="miscellaneousCharge"
                      hide-details
                    ></v-text-field>
                  </div>

                  <div class="add-charge-field add-charge-field--wide">
                    <label class="add-charge-label">Comment</label>
                    <v-text-field
                      class="add-charge-input"
                      placeholder="Comment"
                      :disabled="processing"
                      type="text"
                      v-model="comments"
                      autocomplete="off"
                      counter
                      maxlength="75"
                    ></v-text-field>
                  </div>
                </div>

                <div class="add-charge-proof">
                  <ul v-if="document.length" class="add-charge-docs">
                    <li
                      :key="i"
                      v-for="(doc, i) in document"
                      class="list"
                      ref="documentList"
                    >
                      <button
                        type="button"
                        v-show="document"
                        @click="removeImage(i)"
                      >
                        <span class="imageClose">&times;</span>
                      </button>

                      <a
                        :href="doc"
                        class="document-link"
                        v-if="doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'"
                        target="_blank"
                      >
                        <img src="../../assets/pfd.png" />
                      </a>
                      <a
                        :href="doc"
                        class="document-link"
                        target="_blank"
                        v-else
                      >
                        <img
                          src="../../assets/docimg.webp"
                          height="72"
                          width="75"
                        />
                      </a>
                    </li>
                  </ul>

                  <div class="upload-btn-wrapper">
                    <button
                      v-if="document.length < 30"
                      type="button"
                      class="btn add-charge-upload-btn"
                    >
                      + Additional Charges Proof
                    </button>
                    <input
                      :disabled="processing"
                      ref="fileUpload"
                      id="fileUpload"
                      type="file"
                      multiple
                      accept=".pdf, .jpeg, .jpg, .png"
                      @change="uploadDocument"
                    />
                  </div>
                </div>
              </div>
            </v-card-text>

            <v-card-actions class="add-charge-actions">
              <v-snackbar
                :timeout="3000"
                bottom
                color="red darken-2"
                v-model="x.error"
                class="white--text"
                v-if="x.error"
                >{{ x.error }}</v-snackbar
              >
              <v-spacer></v-spacer>
              <v-btn
                class="add-charge-cancel-btn"
                color="blue darken-1"
                :disabled="processing"
                flat
                @click="close"
                >Close</v-btn
              >
              <v-btn
                class="add-charge-submit-btn"
                color="orange darken-1"
                dark
                :disabled="processing"
                @click="checkStatus(customerId, amount)"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-spacer>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- VAT Dialog -->
    <v-dialog
      v-model="vatDialog"
      persistent
      max-width="400"
      class="add-charge-confirm-dialog"
    >
      <v-card class="add-charge-confirm-card">
        <v-card-title class="add-charge-title add-charge-confirm-title">
          <span class="headline">Apply VAT</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="add-charge-close"
            @click.prevent="vatDialog = false"
            :disabled="processing"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4 add-charge-confirm-body">
          <div class="pb-4">
            <img
              src="../../assets/ConfirmationPi.svg"
              height="230"
              width="350"
              class="spMargin"
            />
          </div>
          <div>Would you like to apply VAT to these additional charges?</div>
        </v-card-text>
        <v-card-actions class="pt-2 pb-5 justfy_c add-charge-confirm-actions">
          <v-btn
            class="add-charge-cancel-btn"
            medium
            style="text-transform: none !important"
            color="grey white--text"
            darken-1
            text
            @click.native="openNoVatConfirmation()"
            >No</v-btn
          >
          <v-btn
            class="add-charge-submit-btn"
            medium
            style="text-transform: none !important"
            color="orange white--text"
            darken-1
            text
            @click.native="proceedWithVAT()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- No VAT Confirmation Dialog -->
    <v-dialog
      v-model="noVatConfirmDialog"
      persistent
      max-width="400"
      class="add-charge-confirm-dialog"
    >
      <v-card class="add-charge-confirm-card">
        <v-card-title class="add-charge-title add-charge-confirm-title">
          <span class="headline">Confirm No VAT</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="add-charge-close"
            @click.prevent="noVatConfirmDialog = false"
            :disabled="processing"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4 add-charge-confirm-body">
          <div class="pb-4">
            <img
              src="../../assets/ConfirmationPi.svg"
              height="230"
              width="350"
              class="spMargin"
            />
          </div>
          <div>Are you sure you want to proceed without VAT?</div>
          <!-- <div class="mt-2" style="color: red">
            VAT will not be applicable in these charges.
          </div> -->
        </v-card-text>
        <v-card-actions class="pt-2 pb-5 justfy_c add-charge-confirm-actions">
          <v-btn
            class="add-charge-cancel-btn"
            medium
            style="text-transform: none !important"
            color="grey white--text"
            darken-1
            text
            @click.native="
              noVatConfirmDialog = false;
              vatDialog = true;
            "
            >Cancel</v-btn
          >
          <v-btn
            class="add-charge-submit-btn"
            medium
            style="text-transform: none !important"
            color="orange white--text"
            darken-1
            text
            @click.native="proceedWithoutVAT()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Credit Limit / Confirmation Dialog -->
    <v-dialog
      v-model="dialog1"
      persistent
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card class="add-charge-confirm-card">
        <v-card-title class="add-charge-title add-charge-confirm-title">
          <span class="headline">Confirmation</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            class="add-charge-close"
            @click.prevent="dialog1 = false"
            :disabled="processing"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-spacer class="spacerclass add-charge-confirm-body-wrap">
          <v-card-text class="pa-4 add-charge-confirm-body">
            <div class="pb-4">
              <img
                src="../../assets/ConfirmationPi.svg"
                height="230"
                width="350"
                class="spMargin"
              />
            </div>
            <div v-if="!!creditLimitError" style="color: red">
              {{ creditLimitError }}
            </div>
            <div>Are you sure you want to add additional charges?</div>
            <div v-if="isVatApply" class="mt-2" style="color: green">
              VAT will be applied to these charges.
            </div>
            <div v-if="!isVatApply" class="mt-2" style="color: red">
              VAT will not be applicable in these charges.
            </div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5 justfy_c add-charge-confirm-actions">
            <v-btn
              class="add-charge-submit-btn add-charge-final-submit-btn"
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              :loading="processing"
              text
              @click.native="addCharges()"
              >Final Submit</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getOperatorRoleLabel } from "@/utils/shipmentLabels";
import moment from "moment";
import Swal from "sweetalert2";
import SuccessDialog from "@/components/Common/SuccessDialog";
import {
  addAdditonalCharges,
  checkCreditLimit,
  additonalChargesAssignmentList,
  uploadImage,
  getAdditionalChargeList,
} from "@/constants/api-urls.js";
import { StorageKeys } from "../../constants/constants";
export default {
  data() {
    return {
      descriptionType: "",
      descriptionTypeList: [
        "Toll Charges",
        "Sila Charges",
        "Batha Charges",
        "Detention Charges",
        "Token Charges",
        "Customs Clearance Charges",
        "Weightment Charges",
        "Bahrain Causeway Charges",
        "Inspection Charges",
        "Others",
      ],
      additionalChargeList: [],
      customerStatus: "",
      creditLimitError: "",
      priceType: "Exclusive",
      options: {
        color: "#ffc04c",
        width: 400,
        zIndex: 200,
      },
      dialog1: false,
      vatDialog: false,
      noVatConfirmDialog: false, // New dialog for "No VAT" confirmation
      isVatApply: false,
      operationName: "",
      AssignmentId: [],
      ids: "",
      currency1: "",
      documents: [],
      document: [],
      x: {
        error: null,
        success1: false,
      },
      amount: "",
      costMargin: "",
      miscellaneousCharge: "",
      comments: null,
      commentsArabic: null,
      items: [],
      processing: false,
      miscellaneousChargeShow: false,
      reason: "",
      dialog: false,
      disStatus: false,
      loading: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "This field is required.",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },
    };
  },
  watch: {
    amount(val) {},
  },
  props: {
    jobType: [String, Number],
    jobId: String,
    assId: Number,
    charges: Number,
    status: Number,
    chargesType: String,
    viewOnly: Boolean,
    currency: String,
    assign_id: String,
    customerId: Number,
    sourceCountry: String,
    destinationCountry: String,
    destinationCity: String,
    VendorWorkingCountry: String,
  },
  computed: {
    operatorRoleLabel() {
      return getOperatorRoleLabel(this.jobType);
    },
    operatorChargesLabel() {
      const jobType = String(this.jobType || "1");
      if (jobType === "2") return "Carrier Charges";
      if (jobType === "3") return "Vessel Charges";
      return "Driver Charges";
    },
  },
  created() {
    window.addEventListener("offline", () => {
      this.close();
    });

    if (!navigator.onLine) {
      this.loading = false;
      this.x.error =
        "Your internet connection seems to be offline.Please try again.";
      setTimeout(() => {
        this.x.error = "";
      }, 3000);
      return;
    }
    this.customerStatus = localStorage.getItem("cust-status");

    this.currency1 = this.$props.currency.toString() || "";
    this.ids = this.$props.assId;
  },
  components: {
    SuccessDialog,
  },
  methods: {
    async check() {
      console.log();
      this.processing = true;
      if (this.$route.name == "Accounts")
        this.operationName = "additional-charge-for-accounts";
      if (this.$route.name != "Accounts")
        this.operationName = "edit-additional-charges";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.dialog = true;
        this.loading = false;
        this.processing = false;

        this.fetchAdditionalChargeList();

        this.amount = "";
        this.costMargin = "";
        if (this.$props.currency) {
          this.currency1 = this.$props.currency;
          this.priceType = "Exclusive";
        } else {
          this.processing = false;
          return;
        }
      }
    },

    fetchAdditionalChargeList() {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      this.axios.defaults.headers.common["authorization"] = `bearer ${token}`;

      let obj = [];

      obj.push(`country=${this.VendorWorkingCountry}`);

      obj.push(`destination=${this.destinationCountry}`);
      obj.push(`source=${this.sourceCountry}`);

      let Url = getAdditionalChargeList;
      let params = obj.join("&");
      Url = Url + params;

      this.axios.get(this.constants.apiUrl + Url).then((response) => {
        let data = [];
        data = response.data.data;

        data.forEach((element) => {
          this.additionalChargeList.push(element.name);
        });
      });
    },
    cleanData() {
      this.costMargin = "";
      this.amount = "";
      this.miscellaneousCharge = "";
    },
    checkStatus(id, amount) {
      if (!navigator.onLine) {
        this.dialog = false;
        this.processing = false;
        this.loading = false;
        Swal.fire({
          title: "Oops!",
          text: "Your internet connection seems to be offline.Please try again.",
          type: "error",
          allowOutsideClick: false,
          confirmButtonColor: "orange",
          confirmButtonText: "Okay",
        }).then((result) => {
          if (result.value) {
            this.processing = false;
            this.loading = false;
          }
        });
      }

      if (this.$refs.form.validate()) {
        this.processing = true;
        if (!this.assId) {
          this.processing = false;
          this.x.error = "Please select assignment id";
          return false;
        }

        if (!this.miscellaneousChargeShow) {
          if (!this.amount) {
            this.processing = false;
            this.x.error = `Please provide ${this.operatorRoleLabel.toLowerCase()} charges`;
            return false;
          }
          if (!this.costMargin) {
            this.processing = false;
            this.x.error = "Please provide customer price";
            return false;
          }
          if (this.amount) {
            if (this.amount >= 1000000) {
              this.processing = false;
              this.x.error =
                `${this.operatorRoleLabel} charges must be less than or equal to 1000000`;
              return false;
            }
            if (!this.amount.match(/^\d+(?:\.\d{1,2})?$/)) {
              this.processing = false;
              this.x.error = `${this.operatorRoleLabel} charges must be up to 2 decimal places`;
              return false;
            }
          }
          if (this.costMargin) {
            if (this.costMargin >= 1000000) {
              this.processing = false;
              this.x.error =
                "Customer Price must be less than or equal to 1000000 ";
              return false;
            }
            if (!this.costMargin.match(/^\d+(?:\.\d{1,2})?$/)) {
              this.processing = false;
              this.x.error = "Customer Price must be upto 2 decimal places";
              return false;
            }
          }
        } else {
          if (
            !this.miscellaneousCharge ||
            parseFloat(this.miscellaneousCharge) == 0
          ) {
            this.processing = false;
            this.x.error = "Please provide miscellaneous charges";
            return false;
          }
          if (this.miscellaneousCharge) {
            if (this.miscellaneousCharge >= 1000000) {
              this.processing = false;
              this.x.error =
                "Miscellaneous Charges must be less than or equal to 1000000 ";
              return false;
            }
            if (!this.miscellaneousCharge.match(/^\d+(?:\.\d{1,2})?$/)) {
              this.processing = false;
              this.x.error =
                "Miscellaneous Charges must be upto 2 decimal places";
              return false;
            }
          }
        }

        if (!this.descriptionType) {
          this.processing = false;
          this.x.error = "Please select description type before moving ahead";
          return false;
        }
        if (
          this.descriptionType &&
          this.descriptionType == "Others" &&
          (!this.comments || !this.comments.trim())
        ) {
          this.processing = false;
          this.x.error = "Please provide description text before moving ahead";
          return false;
        }
        if (
          parseFloat(this.amount) > parseFloat(this.costMargin) &&
          parseFloat(this.costMargin) !== 0
        ) {
          this.processing = false;
          this.x.error =
            `The Customer Price amount should be equal to or greater than the ${this.operatorRoleLabel.toLowerCase()} charges.`;
          return false;
        }
        if (
          parseFloat(this.amount) < 1 &&
          parseFloat(this.costMargin) < 1 &&
          !this.miscellaneousChargeShow
        ) {
          this.processing = false;
          this.x.error = `Please fill either customer price or ${this.operatorRoleLabel.toLowerCase()} charges`;
          return false;
        }

        // Open VAT dialog first
        this.processing = false;
        this.dialog = false;
        this.vatDialog = true;
      }
    },

    // New method to handle the "No" VAT option with confirmation
    openNoVatConfirmation() {
      this.vatDialog = false;
      this.noVatConfirmDialog = true;
    },

    // Process after VAT selection
    proceedWithVAT() {
      this.isVatApply = true;
      this.vatDialog = false;
      this.checkCreditAndProceed();
    },

    proceedWithoutVAT() {
      this.isVatApply = false;
      this.noVatConfirmDialog = false;
      this.checkCreditAndProceed();
    },

    checkCreditAndProceed() {
      this.processing = true;

      // Only check credit limit if amount is provided
      if (this.amount) {
        let url = checkCreditLimit;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = {
          userId: this.customerId.toString(),
          price: this.amount,
          oldPrice: "0",
        };

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            if (response.status === 200) {
              this.dialog1 = true;
              this.processing = false;
            }
          },
          (error) => {
            this.processing = false;

            if (error.response.data.statusCode === 400) {
              this.x.error = error.response.data.message;
            } else if (error.response.data.statusCode === 402) {
              this.creditLimitError = error.response.data.message;
              this.dialog1 = true;
            } else {
              this.x.error = error.response.data.message;
            }
          }
        );
      } else {
        // If no amount, just show confirmation dialog
        this.dialog1 = true;
        this.processing = false;
      }
    },

    assigments() {
      this.loading = true;
      const data = {
        JobId: this.$route.params.id,
      };

      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const { apiUrl } = this.constants;
      this.axios
        .post(`${apiUrl}${additonalChargesAssignmentList}`, data, config)
        .then(
          (response) => {
            const { data } = response.data;
            this.count = response.data.data.count;
            this.AssignmentId = response.data.data.data;
            this.loading = false;
          },
          (error) => {
            this.error = error.response.data.message;
            this.loading = false;
          }
        );
    },

    removeImage(key) {
      this.document.splice(key, 1);
    },
    close() {
      this.dialog = false;
      this.document = [];
      this.additionalChargeList = [];
      this.priceType = "Exclusive";
      this.amount = "";
      this.$refs.form.resetValidation();
      this.comments = "";
      this.commentsArabic = "";
      this.isVatApply = false;
      this.descriptionType = "";
    },
    uploadDocument(e) {
      this.error = null;
      var files = e.target.files || e.dataTransfer.files;
      let x = [...files];
      setTimeout(() => {
        this.$refs.fileUpload.value = "";
      }, 6000);
      if (!files.length) return;

      Array.from(x).forEach((y, i) => {
        this.createImage(files[i]);
      });
    },
    createImage(file) {
      let size = file.size / 1024 / 1024;
      // -------- FILE SIZE CHECK
      if (size > 5) {
        this.x.error = "Please upload proof with size less than 5MB!";

        return false;
      }
      if (
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/png" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpeg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !==
          "application/pdf"
      ) {
        this.x.error =
          "Please upload proof of file type png , jpg ,jpeg or pdf!";
        return false;
      } else {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = (e) => {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.upload(file);
      }
    },
    upload(file) {
      this.processing = true;
      const formData = new FormData();
      formData.append("image", file);

      this.axios({
        url: `${this.constants.apiUrl}${uploadImage}`,
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(
        (response) => {
          this.processing = false;
          const { statusCode } = response.data;
          if (statusCode === 200) {
            if (this.document.length < 30) {
              this.document.push(response.data.data.original);
              return;
            } else {
              this.x.error = "Maximum 30 proofs can be uploaded!";
              return false;
            }
          } else {
            this.x.error = "Failed to upload image";
          }
          this.loading = false;
        },
        (error) => {
          this.error = "Failed to upload image";
          this.processing = false;
        }
      );
    },
    async addCharges() {
      if (this.$route.name == "Accounts")
        this.operationName = "additional-charge-for-accounts";
      if (this.$route.name != "Accounts")
        this.operationName = "edit-additional-charges";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.processing = true;
        let url = addAdditonalCharges;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        var body = {
          assignmentId: this.assign_id.toString(),
          comments: this.comments,
          isVatApplied: this.isVatApply, // Add VAT flag to API body
          jobId: this.$props.jobId.toString(),
          documents: this.document,
          chargesType: this.priceType || "Exclusive",
        };

        if (this.comments) {
          body.description = this.comments;
        }
        if (this.amount) {
          if (Number(this.amount) == 0) {
            body.amount = "0";
          } else {
            body.amount = this.amount;
          }
        }

        if (this.costMargin) {
          if (Number(this.costMargin) == 0) {
            body.costMargin = "0";
          } else {
            body.costMargin = this.costMargin;
          }
        }
        if (this.miscellaneousCharge) {
          if (Number(this.miscellaneousCharge) == 0) {
            body.miscellaneousCharge = "0";
          } else {
            body.miscellaneousCharge = this.miscellaneousCharge;
          }
        }

        if (this.descriptionType) {
          if (this.descriptionType == "Others") {
            body.others = true;
            body.comments = this.comments;
          } else {
            body.others = false;
            body.comments = this.descriptionType;
          }
        }

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            var amount = this.amount;
            this.processing = false;
            this.loading = false;
            this.dialog = false;
            this.dialog1 = false;
            this.$eventBus.$emit("additional-charges-added", amount);
            // this.$eventBus.$emit("success");
            this.$emit("successAdditionalCharges");
            this.amount = "";
            this.costMargin = "";
            this.miscellaneousCharge = "";
            this.miscellaneousChargeShow = false;
            this.dialog = false;
            this.comments = null;
            this.commentsArabic = null;

            this.descriptionType = "";

            this.x.success1 = true;
            this.document = [];
          },
          (error) => {
            this.processing = false;
            this.loading = false;
            this.dialog = true;
            this.x.error = error.response.data.error;
          }
        );
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
.p-16 {
  padding: 16px !important;
}

.add-charge-card,
.add-charge-confirm-card {
  background: var(--oms-surface, #ffffff) !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  border-radius: 12px !important;
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden;
}

.add-charge-title {
  align-items: center;
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-bottom: 1px solid var(--oms-border, #e4e1d9);
  color: var(--oms-ink-strong, #1a1916) !important;
  display: flex;
  min-height: 3.75rem;
  padding: 1rem 1.25rem !important;
}

.add-charge-title .headline {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 18px !important;
  font-weight: 900;
  letter-spacing: 0 !important;
}

.add-charge-close {
  align-items: center !important;
  background: var(--oms-primary-soft, #fff7ed) !important;
  border: 1px solid #f6d9bb !important;
  border-radius: 50% !important;
  box-shadow: none !important;
  color: var(--oms-primary-dark, #c55a00) !important;
  display: inline-flex !important;
  height: 36px !important;
  justify-content: center !important;
  margin: 0 !important;
  min-width: 36px !important;
  width: 36px !important;
}

/* .add-charge-close:hover {
  background: #ffedd5 !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
} */

.add-charge-close ::v-deep .v-icon {
  color: var(--oms-primary-dark, #c55a00) !important;
  font-size: 20px !important;
}

.add-charge-body {
  background: var(--oms-surface, #ffffff);
  display: block;
  max-height: min(72vh, 42rem);
  overflow-y: auto;
}

.add-charge-content {
  padding: 0 !important;
}

.add-charge-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.15rem 1.25rem 1.35rem;
}

.add-charge-switch {
  margin: 0 !important;
  padding: 0 !important;
}

.add-charge-switch ::v-deep .v-input__control {
  min-height: 0 !important;
}

.add-charge-price-type {
  margin: 0;
}

.add-charge-hint {
  color: var(--oms-muted, #74716a);
  font-size: 0.75rem;
  line-height: 1.4;
  margin: 0;
}

.add-charge-grid {
  display: grid;
  gap: 1rem 1.15rem;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

/* Simple fields: a plain label sitting above a boxed input (no floating label) */
.add-charge-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
  width: 100%;
}

.add-charge-label {
  color: var(--oms-ink, #3a382f);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.add-charge-input {
  margin: 0 !important;
  min-width: 0;
  padding: 0 !important;
  width: 100% !important;
}

.add-charge-field--wide {
  grid-column: 1 / -1;
}

.add-charge-proof {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 0.25rem;
}

.add-charge-docs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
}

@media (max-width: 40rem) {
  .add-charge-grid {
    grid-template-columns: 1fr;
  }
}

.add-charge-input ::v-deep .v-input__slot {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid var(--oms-border, #e4e1d9) !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  margin-bottom: 0 !important;
  min-height: 2.75rem !important;
  padding: 0 0.85rem !important;
}

/* Hide Vuetify's underline; the box border is the only outline */
.add-charge-input ::v-deep .v-input__slot::before,
.add-charge-input ::v-deep .v-input__slot::after {
  display: none !important;
}

.add-charge-input ::v-deep .v-text-field__slot,
.add-charge-input ::v-deep .v-select__slot {
  align-items: center;
  min-height: 0;
}

.add-charge-input ::v-deep .v-select__selections {
  padding-top: 0 !important;
}

.add-charge-input ::v-deep input {
  color: var(--oms-ink, #3a382f) !important;
  font-size: 13px !important;
  margin-top: 0 !important;
  padding: 0 !important;
}

.add-charge-input ::v-deep input::placeholder {
  color: var(--oms-muted, #9a978f) !important;
}

.add-charge-input ::v-deep .v-text-field__suffix,
.add-charge-input ::v-deep .v-select__selection {
  color: var(--oms-ink, #3a382f) !important;
  font-size: 13px !important;
  font-weight: 700;
}

.add-charge-input ::v-deep .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
}

.add-charge-input.v-input--is-disabled ::v-deep .v-input__slot {
  background: var(--oms-surface-soft, #faf9f6) !important;
}

.add-charge-input ::v-deep .v-text-field__details {
  margin-top: 0.3rem !important;
  padding: 0 !important;
}

.add-charge-input ::v-deep .v-counter {
  color: var(--oms-muted, #74716a);
  font-size: 12px;
}

.add-charge-actions,
.add-charge-confirm-actions {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border-top: 1px solid var(--oms-border, #e4e1d9);
  padding: 0.85rem 1.25rem !important;
}

.add-charge-actions {
  justify-content: flex-end;
}

.add-charge-confirm-actions {
  justify-content: center;
}

.add-charge-cancel-btn,
.add-charge-submit-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 38px !important;
  letter-spacing: 0 !important;
  min-width: 84px !important;
  text-transform: none !important;
}

.add-charge-cancel-btn {
  background: #ffffff !important;
  border: 1.5px solid var(--oms-primary, #ea7a1c) !important;
  color: var(--oms-primary, #ea7a1c) !important;
}

.add-charge-cancel-btn ::v-deep .v-btn__content {
  color: var(--oms-primary, #ea7a1c) !important;
}

.add-charge-submit-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.add-charge-submit-btn ::v-deep .v-btn__content {
  color: #ffffff !important;
}

.add-charge-final-submit-btn {
  min-width: 112px !important;
}

.add-charge-confirm-body,
.add-charge-confirm-body-wrap {
  text-align: center;
}

.add-charge-trigger-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  border: 1px solid var(--oms-primary, #ea7a1c) !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(245, 130, 32, 0.25) !important;
  color: #ffffff !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  height: 36px !important;
  letter-spacing: 0 !important;
  opacity: 1 !important;
  text-transform: none !important;
}

.add-charge-trigger-btn ::v-deep .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.add-charge-trigger-btn.v-btn--disabled,
.add-charge-trigger-btn[disabled] {
  background: #f3ece4 !important;
  border: 1px solid #e2d5c6 !important;
  box-shadow: none !important;
  color: #8a6a4a !important;
  opacity: 1 !important;
}

.add-charge-trigger-btn.v-btn--disabled ::v-deep .v-btn__content,
.add-charge-trigger-btn[disabled] ::v-deep .v-btn__content {
  color: #8a6a4a !important;
  opacity: 1 !important;
}

.add-charge-upload-btn {
  border-radius: 8px !important;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.upload-btn-wrapper a {
  margin-left: 10px;
}
.upload-btn-wrapper .btn,
.upload-btn-wrapper .view-btn {
  border: 2px solid #ea7a1c;
  color: #ea7a1c;
  background-color: white;
  padding: 8px 20px;
  cursor: pointer !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
}
.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.break_long_text {
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}
.user {
  padding: 10px;
}
.activityLog {
  margin: 0 auto;
  width: 80%;
}

.activity {
  margin: auto;
}
.tooltip {
  font-size: 18px;
  font-weight: 500;
}
.tooltip-op {
  left: calc(100% - 9.2%) !important;
  opacity: 1 !important;
}
.comments-view .v-toolbar {
  width: 100%;
  /* margin-left: 25%; */
}
.v-toolbar--fixed {
  position: inherit;
}
.assign-driver-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #bebebe;
  border: 2px solid grey;
  padding: 2px 5px;
  border-radius: 5px;
}
.document-link {
  text-decoration: none;
}
.ttt button select {
  border: none !important;
}
.imageClose {
  position: absolute;
  width: 15px;
  bottom: 80px;
  height: 15px;
  background: #000;
  border-radius: 50%;
  color: #fff !important;
  line-height: 15px;
  top: -6px;
  left: 2px;
}

.message {
  display: inline-block;
  margin: 0 50px;
}
.communication {
  width: 40%;
}
.success {
  font-size: 18px;
  font-weight: 600;
}
.messagebtn {
  margin: 0 auto;
}
.list {
  display: inline-block;
  position: relative;
}
.thumb {
  width: 80px;
  height: 80px;
}

.custom-file-upload {
  border: none;
  display: inline-block;
  background: #ea7a1c;
  font-size: 16px;
  color: #fff;
  padding: 10px 12px;
  cursor: pointer;
}
</style>

<style>
.application .v-dialog.add-charge-dialog {
  margin: 1.5rem auto !important;
  max-width: min(48rem, calc(100vw - 2rem)) !important;
  width: min(48rem, calc(100vw - 2rem)) !important;
}
</style>
